import { render, staticRenderFns } from "./TranTypeHelpList.vue?vue&type=template&id=84cbbc4e&"
import script from "./TranTypeHelpList.vue?vue&type=script&lang=js&"
export * from "./TranTypeHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports